import React from 'react'

const Canvas = () => {
  return (
    <div className="material-canvas">
      <div className="canvas-section">
        <canvas id="canvas" width="0" height="0" />
      </div>
    </div>
  )
}

export default Canvas
